import { render, staticRenderFns } from "./ManagementEntityStats.vue?vue&type=template&id=1568ac2b&scoped=true&"
import script from "./ManagementEntityStats.vue?vue&type=script&lang=js&"
export * from "./ManagementEntityStats.vue?vue&type=script&lang=js&"
import style0 from "./ManagementEntityStats.vue?vue&type=style&index=0&id=1568ac2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568ac2b",
  null
  
)

export default component.exports